import type { QrCodeDoc } from "./types";
import { countBuffetTours } from "./tourCount";

const isOverrideValue = (v: unknown): v is number =>
  typeof v === "number" && Number.isFinite(v) && v >= 0;

/**
 * Settings the manager sets on one table (QRCode.menuOverride):
 * - waitingTime / maxOrders, when set, replace the menu or restaurant value;
 * - timerResetTour is the tour count at the moment the staff reset the timer:
 *   no waiting until the next tour is sent.
 * Same rule server side (functions/src/lib/menuSettings.ts, which re-checks the
 * cooldown and maxOrders on submit), on the web tablet (src/utils/menuOverride.js)
 * and on the native tablet (we-kiosk-order-app orderMath.applyMenuOverride).
 */
export const applyMenuOverride = <T extends { waitingTime: number; maxOrders: number }>(
  menu: T,
  qrCode: QrCodeDoc | null
): T => {
  const override = qrCode?.menuOverride;
  if (!override) return menu;
  const next = { ...menu };
  if (isOverrideValue(override.waitingTime)) next.waitingTime = override.waitingTime;
  if (isOverrideValue(override.maxOrders)) next.maxOrders = override.maxOrders;
  if (
    isOverrideValue(override.timerResetTour) &&
    override.timerResetTour === countBuffetTours(qrCode?.order ?? [])
  ) {
    next.waitingTime = 0;
  }
  return next;
};
